<div class="sidebar included">
    <app-sidebar-header [title]="'ancillaries.group.MEAL' | ibeadmin: 'sync'"></app-sidebar-header>

    <div class="sidebar__body sl--scrollable" #sidebar__body>

        <app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>

        <div *ngIf="showMeal" class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>

        <div class="sidebar__info--flight-info top-gap" *ngIf="!directFlight && stops.length">
			<p>{{ 'addMoreSidebars.seatmap.text.flightHas' | ibeadmin:'sync'}} {{stops.length}} {{ 'addMoreSidebars.specialMeals.texts.stop' | ibeadmin:'sync'}}, {{ 'whatsIncludedSidebars.detailsSnacks.texts.chooseSegment' | ibeadmin:'sync'}}</p>
			<app-segmented-control-radio 
                classes="sidebar__info--flight-info--options" 
                (selected)="INDRA_selectedStop($event)" 
                [_value]="selectedStop" 
                [options]="stops">
            </app-segmented-control-radio>
		</div>

        <app-included-per-passenger [mealSegmentsData]="mealSegmentsData" [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="flight">
        </app-included-per-passenger>

        <div *ngIf="INDRA_hasInfant()" class="sidebar-flight-text">
            <h2 class="title-h2">
                {{ 'whatsIncludedSidebars.detailsSnacks.titles.babyFood' | ibeadmin: 'sync' }}
            </h2>
            <p class="muted">
                {{ 'whatsIncludedSidebars.detailsSnacks.texts.babyFood' | ibeadmin: 'sync' }}
            </p>
            <a (click)="INDRA_gotoURL('externalURLs.aboutMealsForBabies')" href="javascript:;" class="link extras-feature__link link--external" aria-label="Open All about meals for babies and children, opens new window">
				{{ 'whatsIncludedSidebars.detailsSnacks.label.openDialogAboutBabyMeals' | ibeadmin: 'sync' }}
			</a>
        </div>

        <app-compare-brands [feature]="feature" [brand]="brand" [segment]="selectedStop" [snack]="hasSnack[selectedStop]" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>

        <div class="sidebar-flight-text" *ngIf="reviewFlights && showAddButton">
            <h2 class="title-h2">
                {{'whatsIncludedSidebars.detailsSnacks.titles.preorderMeal' | ibeadmin:'sync'}}
            </h2>
            <p class="muted">
                {{'whatsIncludedSidebars.detailsSnacks.texts.mainCoursePreorder' | ibeadmin:'sync'}}
            </p>
            <p class="muted" *ngIf="!isBusinessBrand">
                {{ 'whatsIncludedSidebars.detailsSnacks.texts.specialMeals' | ibeadmin: 'sync' }}
            </p>
            <button class="button " (click)="openMealSidebar()" [attr.aria-label]="'whatsIncludedSidebars.detailsSnacks.button.selectMainCourse' | ibeadmin:'sync'">
				{{'whatsIncludedSidebars.detailsSnacks.button.selectMainCourse' | ibeadmin:'sync'}}
			</button>
        </div>

        <div class="extras__helper with-notification">
            <div class="">
                <a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">
					{{ 'whatsIncludedSidebars.detailsSnacks.texts.closeWindow' | ibeadmin: 'sync' }}
				</a>
            </div>
        </div>
    </div>
    <div #sidebar__footer class="sidebar__footer "></div>
</div>